<template>
  <div id="grid-captura">
    <v-container grid-list-xl fluid>
      <v-layout>
        <carga-masiva
          :apiValidateDocument="apiValidateDocument"
          :apiSaveDocument="apiSaveDocument"
          :apiDownloadDocument="apiDownloadDocument"
          :templateTitle="templateTitle"
          :tipoCarga="tipoCarga"
        ></carga-masiva>
      </v-layout>
      <v-layout justify-center>
        <v-flex xs12 md4>
          <v-select
            v-model="nivelValue"
            :items="nivelSelect"
            item-text="nombre"
            item-value="codigo"
            label="Nivel *"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="tipoPruebaValue"
            :items="tipoPruebaSelect"
            label="Tipo Prueba *"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="regionValue"
            :items="regionSelect"
            item-text="nombre"
            item-value="codigo"
            label="Region *"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fechaValue"
                label="Fecha de consolidacion"
                prepend-icon="event"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaValue"
              @input="menu1 = false"
              no-title
              locale="es"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <v-btn fab dark color="teal" title="Filtrar detalle" @click="filtro()">
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>

      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              :headers="headers"
              :items="itemsCaptura"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              @page-count="pageCount = $event"
              class="elevation-1"
              hide-actions
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.s_nivel }}</td>
                <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
                <td class="text-xs-left">{{ props.item.documento }}</td>
                <td class="text-xs-left">{{ props.item.codigoCurso }}</td>
                <td class="text-xs-left">{{ props.item.serie }}</td>
                <td class="text-xs-left">{{ props.item.cantImagenes }}</td>
                <td class="text-xs-left">{{ props.item.cantPaginas }}</td>
                <td class="text-xs-left">{{ props.item.fechaCaptura }}</td>
                <td class="text-xs-left">{{ props.item.fechaModificacion }}</td>
              </template>
            </v-data-table>
          </template>
        </v-flex>
      </v-layout>

      <!--  dsoto 10-11-2022 -->
      <v-flex xs12 sm6>
        <v-text-field
          value=""
          label="Total de Registros"
          v-model="cantRegistros"
          disabled
        ></v-text-field>
      </v-flex>
      <!--  dsoto 10-11-2022 -->

      <div class="text-center pt-2">
        <v-pagination
          @input="changePage(page)"
          v-model="page"
          :length="totalPages"
          :total-visible="9"
          circle
        >
        </v-pagination>
      </div>

      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          v-if="botonDescarga == true"
          color="primary"
          @click="descargaMasiva()"
        >
          Descarga filtrada
          <v-icon right dark>folder</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import { misMixins } from "@/mixins/myMixing.js";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import CargaMasiva from "@/components/CargaMasiva.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "grid-captura",

  components: {
    AlertEmpty,
    Loading,
    CargaMasiva,
    LoadingDescarga,
  },
  props: {
    rowsTable: String,
    tipeView: String,
  },
  mixins: [misMixins],

  data() {
    return {
      menu1: false,
      page: 1,
      pages: 1,
      totalPages: 0,
      pagesValue: null,
      pagesSelect: [],
      codCursoValue: null,
      codCursoSelect: [],
      botonDescarga: false,
      dialogLoading: false,
      loading: false,
      loading1: false,
      tipeArchive: "",
      alerta: false,
      dialog: false,
      id: "",
      totalRegistro: "",
      rowsPerPageItems: [50],
      pagination: {
        page: 1,
        rowsPerPage: 50,
        pages: 0,
      },
      totalRegistros: "",
      idContrato: "",
      headers: [
        { text: "Nivel", align: "left", sortable: false, value: "rut" },
        { text: "Tipo Prueba", sortable: false, value: "candidato" },
        { text: "Documento", sortable: false, value: "evaluacion" },
        { text: "CodCurso", sortable: false, value: "fecha" },
        { text: "Serie", sortable: false, value: "fecha" },
        { text: "CantImagenes", sortable: false, value: "fecha" },
        { text: "CantPaginas", sortable: false, value: "fecha" },
        { text: "FechaConsolidacion", sortable: false, value: "fecha" },
        { text: "FechaReporte", sortable: false, value: "fecha" },
      ],
      itemsCaptura: [],
      itemsFiltro: [],
      usuarioLoggedTipe: "",
      itemsEvaluacion: [],
      idUserLogged: "",
      proceso: "",
      nivelSelect: [],
      nivelValue: null,
      fechaValue: null,
      documentoValue: null,
      documentoSelect: [],
      tipoPruebaValue: null,
      regionValue: null,
      tipoPruebaSelect: [],
      regionSelect: [],
      //----CARGA MASIVA---
      apiValidateDocument: "",
      apiSaveDocument: "",
      apiDownloadDocument: "",
      templateTitle: "",
      tipoCarga: "CSV",
      // dsoto 10-11-2022
      cantRegistros: 0,
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 5000);
    },
  },

  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;

    //se indican las apis a utilizar
    this.apiValidateDocument = "/captura/seguimiento/captura/preProcess";
    this.apiSaveDocument = "/captura/seguimiento/captura/updateMasivo";
    this.apiDownloadDocument =
      "/captura/seguimiento/scan/downloadPlantilla/captura/";
    this.templateTitle = "Planilla_Captura";
    this.loadData();
    this.loadDataFiltros();
  },
  mounted() {},
  computed: {},
  methods: {
    async loadCapturaFilter() {
      this.body = {
        nivel: this.nivelValue,
        tipoPrueba: this.tipoPruebaValue,
        idContrato: this.idContrato,
        region: this.regionValue,
        fechaCaptura:
          this.fechaValue && this.fechaValue != null
            ? this.formatoFecha(this.fechaValue)
            : null,
        pageSize: 50,
        pageNumber: this.page,
      };
      return await axios
        .post("/captura/seguimiento/captura/filters", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message); */
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;

      this.itemsCaptura = await this.loadCapturaFilter();

      if (this.itemsCaptura.length > 0) {
        this.loadPagesSelect();

        this.pages = this.itemsCaptura.length;
        this.pages = this.pagesValue;
        this.pages = this.pages[0];

        this.totalPages = Math.ceil(this.pages / this.rowsPerPageItems); // dsoto 10-11-2022
        this.cantRegistros = this.pages; // dsoto 10-11-2022

        this.alerta = false;
        this.botonDescarga = true;

        this.loadNivelSelect();
        this.loadPruebaSelect();
        this.loadRegionesSelect();
      } else {
        this.alerta = true;
        this.page = 1;
        this.totalPages = 0;
        this.pages = 1;
      }
      this.loading = false;
    },

    async loadCapturaFiltros() {
      this.body = {
        nivel: this.nivelValue,
        tipoPrueba: this.tipoPruebaValue,
        idContrato: this.idContrato,
        region: this.regionValue,
        fechaCaptura:
          this.fechaValue && this.fechaValue != null
            ? this.formatoFecha(this.fechaValue)
            : null,
        pageSize: 20,
        pageNumber: this.page,
      };
      return await axios
        .post("/captura/seguimiento/captura/filtros", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message); */
          }
          return [];
        });
    },
    async loadDataFiltros() {
      this.itemsFiltro = await this.loadCapturaFiltros();

      if (this.itemsFiltro.length > 0) {
        this.loadNivelSelect();
        this.loadPruebaSelect();
        this.loadRegionesSelect();
      }
    },

    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.loadData();
    },
    loadPagesSelect() {
      let pag = [];
      this.itemsCaptura.forEach(function (c) {
        let index = pag.findIndex((x) => x.totalRegistros == c.totalRegistros);
        if (index === -1) {
          pag.push(c.totalRegistros);
        }
      });
      this.pagesSelect = pag;
      this.pagesValue = pag;
    },

    loadNivelSelect() {
      let niv = [];
      this.itemsFiltro.forEach(function (d) {
        let index = niv.findIndex((x) => x == d);

        if (index === -1) {
          niv.push({ nombre: d.s_nivel, codigo: d.idNivel });
        }
      });
      this.nivelSelect = niv;
    },
    loadRegionesSelect() {
      let reg = [];
      this.itemsFiltro.forEach(function (d) {
        let index = reg.findIndex((x) => x == d);
        if (index === -1) {
          reg.push({ nombre: d.region, codigo: d.idRegion });
        }
      });
      this.regionSelect = reg;
    },

    loadPruebaSelect() {
      let pru = [];
      this.itemsFiltro.forEach(function (d) {
        let index = pru.findIndex((x) => x == d);
        if (index === -1) {
          pru.push(d.tipoPrueba);
        }
      });
      this.tipoPruebaSelect = pru;
    },

    clear() {
      this.fechaValue = null;
      this.nivelValue = null;
      this.tipoPruebaValue = null;
      this.regionValue = null;
      this.loadData();
    },
    filtro() {
      this.page = 1;
      this.loadData();
    },
    async descargaMasiva() {
      this.dialogLoading = true;
      this.body = {
        nivel: this.nivelValue,
        tipoPrueba: this.tipoPruebaValue,
        idContrato: this.idContrato,
        documento: this.documentoValue,
        fechaCaptura: this.fechaValue,
        region: this.regionValue,
      };
      return await axios
        .post("captura/seguimiento/captura/download", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "DESCARGA_CAPTURA.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          if (error) {
            window.getApp.$emit(
              "ERROR_EXCEPTION",
              "Debe ingresar los datos de nivel, tipo de prueba y region en el filtro"
            );
          }
        });
    },
  },
};
</script>
